import { createSlice } from "@reduxjs/toolkit"

export const defaultState = {
    authHistory: [],
    authType: "Login",
    info: {
        email: "",
        phone: "",
        existingUser: false,
    },
    conflictInfo: {
        optionsList: null,
        header: "",
        description: "",
        cta: {},
        conflictEmail: "",
        number: "",
        conflict: false,
        requiredDetail: null,
    },

    mergeAccountInformation: {
        header: "",
        description: "",
        imageUrl: "",
        ctaLabel: "",
        heading: "",
        steps: [],
    },
}

const newAuthSlice = createSlice({
    name: "authentication",
    initialState: defaultState,
    reducers: {
        clearUserInfo: (state) => {
            state.info = defaultState.info
            state.conflictInfo = defaultState.conflictInfo
            state.mergeAccountInfo = defaultState.mergeAccountInfo
        },

        setAuthType: (state, action) => {
            state.authType = action.payload
        },
        updateAuthHistory: (state, action) => {
            state.authHistory = action.payload
        },
        updateAuthenticationInfo: (state, action) => {
            state.info = { ...state.info, ...action.payload }
        },
        setConflictCaseInfo: (state, action) => {
            state.conflictInfo = {
                ...state.conflictInfo,
                ...action.payload,
            }
        },
        setDefault: () => {
            return defaultState
        },
        mergeAccountInfo: (state, action) => {
            state.mergeAccountInformation = {
                ...state.mergeAccountInformation,
                ...action.payload,
            }
        },

        setModalName: (state, action) => {
            state.modalName = action.payload
        },
    },
})

export const newAuthReducer = newAuthSlice.reducer
export const {
    clearUserInfo,
    setAuthType,
    updateAuthenticationInfo,
    setDefault,
    updateAuthHistory,
    setConflictCaseInfo,
    mergeAccountInfo,
    setModalName,
} = newAuthSlice.actions
